//
/**
 * Returns a new object with only the desired keys
 * @param {Array<string>} keys object keys to keep
 * @param {Object} o source object
 * @return {Object} object with only the desired keys
 */
const filterObject = (keys, o) => {
  const filtered = Object.assign({}, ...keys.map(key => ({ [key]: o[key] })))
  return filtered
}

export default filterObject
